import {createSelector} from 'reselect';
import {isEntityTrack} from '../../../services/albumProvider/albumProvider';
import {albumSelector, trackSelector} from '../../../store/selectors';

export const siteSettingsSelector = (store) => (store.siteSettings ? store.siteSettings : {});
export const styleParamsSelector = createSelector(siteSettingsSelector, (siteSettings) =>
  siteSettings.styleParams ? siteSettings.styleParams : {},
);
export const styleParamsBooleansSelector = createSelector(styleParamsSelector, (styleParams) =>
  styleParams.booleans ? styleParams.booleans : {},
);
export const canShareOptionsSelector = createSelector(styleParamsBooleansSelector, (booleans) => ({
  canShareAlbum: booleans.albumShare === undefined ? true : booleans.albumShare,
  canShareTrack: booleans.trackShare === undefined ? true : booleans.trackShare,
}));

export const canShareEntitySelector = createSelector(
  [albumSelector, trackSelector, canShareOptionsSelector],
  (album, track, {canShareAlbum, canShareTrack}) => {
    return isEntityTrack(album, track) ? canShareTrack : canShareAlbum;
  },
);
